module.exports = __webpack_public_path__ + "static/media/client_img.54ad7694.jpg";